export default function AboutOne() {
  return (
    <div className="small_basket_type">
      <h2>About</h2>
      <p>
        This is the about us page this is the about page this is the about page
        this is the about page this is the about page. This is the about us page
        this is the about page this is the about page this is the about page
        this is the about page. This is the about us page this is the about page
        this is the about page this is the about page this is the about page.
        This is the about us page this is the about page this is the about page
        this is the about page this is the about page. This is the about us page
        this is the about page this is the about page this is the about page
        this is the about page.
      </p>
      <p>
        This is the about us page this is the about page this is the about page
        this is the about page this is the about page. This is the about us page
        this is the about page this is the about page this is the about page
        this is the about page. This is the about us page this is the about page
        this is the about page this is the about page this is the about page.
        This is the about us page this is the about page this is the about page
        this is the about page this is the about page. This is the about us page
        this is the about page this is the about page this is the about page
        this is the about page.
      </p>
      <p>
        This is the about us page this is the about page this is the about page
        this is the about page this is the about page. This is the about us page
        this is the about page this is the about page this is the about page
        this is the about page. This is the about us page this is the about page
        this is the about page this is the about page this is the about page.
        This is the about us page this is the about page this is the about page
        this is the about page this is the about page. This is the about us page
        this is the about page this is the about page this is the about page
        this is the about page.
      </p>
    </div>
  );
}
